// SideSlabsDialog.tsx — Side slab / wing slab attach (ssvar)

import { useState } from 'react';
import DialogBase from './DialogBase';
import { SlotEditor } from './SlotEditor';
import { useShallowStore } from '../store/useStore';
import type { SsVar, SsData } from '../types/panelvar';

const FIELDS = [
  { key: 'mark',      label: 'Mark',      type: 'text'   as const },
  { key: 'side',      label: 'Side',      type: 'text'   as const },
  { key: 'x',         label: 'X',         type: 'number' as const, unit: '"', min: 0 },
  { key: 'width',     label: 'Width',     type: 'number' as const, unit: '"', min: 0 },
  { key: 'height',    label: 'Height',    type: 'number' as const, unit: '"', min: 0 },
  { key: 'depth',     label: 'Depth',     type: 'number' as const, unit: '"', min: 0 },
  { key: 'elevation', label: 'Elevation', type: 'number' as const, unit: '"' },
];

export default function SideSlabsDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [slots, setSlots] = useState<SsVar>(panel?.ssvar ?? []);
  if (!panel) return null;

  return (
    <DialogBase title="Side Slabs (2 max)" onOk={() => updatePanel(panel.id, { ssvar: slots })}>
      <SlotEditor<SsData>
        slots={slots}
        fields={FIELDS}
        maxSlots={2}
        onChange={v => setSlots(v)}
        defaultData={() => ({ mark: '', side: 'left', x: 0, width: 0, height: 0, depth: 6, elevation: 0 })}
        label="Slab"
      />
    </DialogBase>
  );
}
